import styled from 'styled-components'

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  background: ${({ theme }) => `${theme.colors.success}1a`};
  width: fit-content;
  white-space: nowrap;

  span.label {
    font-size: 1.1rem !important;
    line-height: 1.6rem !important;
    font-weight: 500 !important;
    color: ${({ theme }) => theme.colors.success};
  }

  .dot {
    width: 6px;
    height: 6px;
    min-width: 6px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.success};
  }
`
